import type { UniversityFormSection } from "@/modules/corporate/types/sections"
import type { FunctionComponent } from "react"

import Image from "next/image"

import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"
import { Text, TEXT_TYPES, TEXT_WEIGHTS } from "@jobteaser/ui-kit/components/Text/Text"

import { UniversityContact } from "@/modules/corporate/components/Forms/UniversityContact"
import { URL_PATHNAME } from "@/modules/corporate/constants"
import teasyFullTriangle from "@/modules/corporate/images/teasy-full-triangle.svg"
import teasyOutlineTriangle from "@/modules/corporate/images/teasy-outline-long-triangle.svg"
import { useLocale } from "@/modules/locales/useLocale"
import { getAssetImportUrl } from "@/modules/staticAssets/getAssetImportUrl"

import styles from "./Form.module.css"

export type UniversityFormPropsType = {
  section: UniversityFormSection
}

export const UniversityForm: FunctionComponent<UniversityFormPropsType> = ({ section }) => {
  const locale = useLocale()
  const triangleFront = `${getAssetImportUrl(teasyFullTriangle)}`
  const triangleBack = `${getAssetImportUrl(teasyOutlineTriangle)}`

  const redirection = `/${locale}/${URL_PATHNAME}/${section.redirection[0].slug}`

  return (
    <Layout
      className={styles.layout}
      style={
        { "--triangleBack": `url(${triangleBack})`, "--triangleFront": `url(${triangleFront})` } as React.CSSProperties
      }
    >
      <Layout.Column>
        <div className={styles.data}>
          {!!section.title && (
            <Text type={TEXT_TYPES.HEADING} weight={TEXT_WEIGHTS.BLACK} className={styles.title} resetSpacing tag="h1">
              {section.title}
            </Text>
          )}
          {!!section.data.length && (
            <ul className={styles.dataList}>
              {section.data.map(data => (
                <li key={`${data.value}_${data.legend}_${data.longDescription}`} className={styles.dataItem}>
                  {!!data.icon.length && (
                    <Image
                      alt={data.icon[0].description || ""}
                      height={data.icon[0].height || undefined}
                      priority
                      src={data.icon[0].url}
                      width={data.icon[0].width || undefined}
                      className={styles.dataImage}
                    />
                  )}
                  {data.longDescription || data.value}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Layout.Column>
      <Layout.Column className={styles.layoutColumnForm}>
        <div className={styles.form}>
          <UniversityContact
            actionUrl={section.url}
            conditionsPage={section.conditionsPage[0]}
            redirection={redirection}
            footer={section.footer}
          />
        </div>
      </Layout.Column>
    </Layout>
  )
}
